<template>
  <div id="SectionCSRDCheck">
    <UIContainer class="SectionCSRDCheck__container">
      <div class="SectionCSRDCheck__content">
        <div class="SectionCSRDCheck__left">
          <h1 class="SectionCSRDCheck__title">
            Quickly check if your company must comply with the CSRD
          </h1>

          <p class="SectionCSRDCheck__description">
            Get a clear, instant answer on your company's CSRD obligations. Our
            free tool helps you understand your compliance requirements in under
            2 minutes.
          </p>

          <UIButton size="xl" class="SectionCSRDCheck__cta">
            Check now
          </UIButton>
        </div>

        <div class="SectionCSRDCheck__right">
          <img
            src="../assets/csrd.png"
            alt="CSRD"
            class="SectionCSRDCheck__image"
            fetchpriority="high"
            loading="eager"
          />
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionCSRDCheck {
  .SectionCSRDCheck__container {
    padding-top: 2rem;

    @include md {
      padding-top: 4rem;
    }
  }

  .SectionCSRDCheck__content {
    display: flex;
    gap: 2rem;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    @include md {
      flex-direction: row;
    }
  }

  .SectionCSRDCheck__title {
    @include font-size-30px();
    font-weight: 600;
    color: $color-ui-gray-cool-900;

    @include md {
      @include font-size-60px();
    }
  }

  .SectionCSRDCheck__description {
    margin-top: 1.5rem;
    color: $color-ui-gray-cool-600;
    max-width: 30rem;
  }

  .SectionCSRDCheck__cta {
    margin-top: 2rem;
  }

  .SectionCSRDCheck__right {
    width: 100%;
    max-width: 34.375rem;
  }

  .SectionCSRDCheck__image {
    width: 100%;
    max-width: 34.375rem;
    height: auto;
    max-height: 28.625rem;
  }
}
</style>
